import React, { Fragment, useEffect, useState } from 'react'
import './ProductLeaseDetails.scss'
import { BreadCrumb } from '../../../../../Components'
import productLeaseService from '../../../../../Services/productLeaseService'
import { Link, useParams } from 'react-router-dom'
import { Logger } from '../../../../../Helpers/Logger'
import { CurrencyFormatter } from '../../../../../Helpers/CurrencyFormatter'
import { TimeConverter } from '../../../../../Helpers/TimeConverter'
import { ProductLeaseType } from './ProductLease'
import Pay from './Pay'

const ProductLeaseDetails = () => {
  const { uuid } = useParams<{ uuid: string }>()
  const [productLease, setProductLease] = useState<ProductLeaseType>()
  const [loading, setLoading] = useState(false)
  const [showPayModal, setShowPayModal] = useState(false)

  const getProductLease = async () => {
    setLoading(true)
    await productLeaseService.single(uuid).then(
      (response) => {
        setLoading(false)
        setProductLease(response?.data.data)
      },
      (error: { response: object }) => {
        setLoading(false)
        Logger('response error', error.response)
      },
    )
  }

  useEffect(() => {
    getProductLease()
  }, [uuid])

  return (
    <div className='PLPDetails'>
      <div className='container mt-4'>
        <BreadCrumb
          title={'Details'}
          parent={'Product Lease'}
          parentUrl={'plp?tab=productlease'}
          showTitle={false}
        ></BreadCrumb>
      </div>

      <div className='container mt-2'>
        <div className='card border-0'>
          <div className='card-header border-0'>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-6 my-auto d-flex'>
                <div className='title'>
                  {productLease?.user.firstName} {productLease?.user.lastName}
                </div>
                <span className='order-status'>
                  {productLease?.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
              <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-6 my-auto d-flex justify-content-end'>
                <button
                  className='btn btn-sm btn-default px-4'
                  onClick={() => setShowPayModal(true)}
                >
                  Make Payment
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className='card border-0 mt-2'>
          <div className='card-body pb-5 pb-4'>
            <div className='row'>
              <div className='col-md-6'>
                <svg
                  width='48'
                  height='48'
                  viewBox='0 0 48 48'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <circle cx='24' cy='24' r='24' fill='#0E1F33' />
                  <path
                    d='M33.09 18.9795C32.24 18.0395 30.82 17.5695 28.76 17.5695H28.52V17.5295C28.52 15.8495 28.52 13.7695 24.76 13.7695H23.24C19.48 13.7695 19.48 15.8595 19.48 17.5295V17.5795H19.24C17.17 17.5795 15.76 18.0495 14.91 18.9895C13.92 20.0895 13.95 21.5695 14.05 22.5795L14.06 22.6495L14.16 23.6995C14.17 23.7095 14.19 23.7295 14.21 23.7395C14.54 23.9595 14.88 24.1795 15.24 24.3795C15.38 24.4695 15.53 24.5495 15.68 24.6295C17.39 25.5695 19.27 26.1995 21.18 26.5095C21.27 27.4495 21.68 28.5495 23.87 28.5495C26.06 28.5495 26.49 27.4595 26.56 26.4895C28.6 26.1595 30.57 25.4495 32.35 24.4095C32.41 24.3795 32.45 24.3495 32.5 24.3195C32.96 24.0595 33.39 23.7795 33.81 23.4695C33.83 23.4595 33.85 23.4395 33.86 23.4195L33.9 23.0595L33.95 22.5895C33.96 22.5295 33.96 22.4795 33.97 22.4095C34.05 21.3995 34.03 20.0195 33.09 18.9795ZM25.09 25.8295C25.09 26.8895 25.09 27.0495 23.86 27.0495C22.63 27.0495 22.63 26.8595 22.63 25.8395V24.5795H25.09V25.8295ZM20.91 17.5695V17.5295C20.91 15.8295 20.91 15.1995 23.24 15.1995H24.76C27.09 15.1995 27.09 15.8395 27.09 17.5295V17.5795H20.91V17.5695Z'
                    fill='white'
                  />
                  <path
                    opacity='0.4'
                    d='M32.5002 24.2984C32.4502 24.3284 32.4002 24.3584 32.3502 24.3884C30.5702 25.4284 28.6002 26.1284 26.5602 26.4684C26.4802 27.4284 26.0602 28.5284 23.8702 28.5284C21.6802 28.5284 21.2602 27.4384 21.1802 26.4884C19.2702 26.1884 17.3902 25.5584 15.6802 24.6084C15.5302 24.5284 15.3802 24.4484 15.2402 24.3584C14.8802 24.1584 14.5402 23.9384 14.2102 23.7184C14.1902 23.7084 14.1702 23.6884 14.1602 23.6784L14.7702 30.1884C14.9802 32.1784 15.8002 34.2284 20.2002 34.2284H27.8202C32.2202 34.2284 33.0402 32.1784 33.2502 30.1784L33.8802 23.3984C33.8702 23.4184 33.8502 23.4384 33.8302 23.4484C33.4002 23.7584 32.9602 24.0484 32.5002 24.2984Z'
                    fill='white'
                  />
                </svg>

                <div className='value mb-4'>Customer Details</div>

                <div className='label mt-3'>Full Name</div>
                <div className='value'>
                  {productLease?.user.firstName} {productLease?.user.lastName}
                </div>

                <div className='label mt-4'>Email</div>
                <div className='value'>{productLease?.user.emailAddress}</div>

                <div className='label mt-4'>Phone Number</div>
                <div className='value'>{productLease?.user.msisdn}</div>

                <div className='label mt-4'>Principal Amount</div>
                <div className='value'>
                  {productLease?.currency}{' '}
                  {CurrencyFormatter(productLease?.principalAmountMajor || 0)}
                </div>

                <div className='label mt-4'>Total Debt</div>
                <div className='value'>
                  {productLease?.currency} {CurrencyFormatter(productLease?.totalDebtMajor || 0)}
                </div>

                <div className='label mt-4'>Next Payment Due</div>
                <div className='value'>
                  {TimeConverter(productLease?.nextLeasePaymentDueDate || '')}
                </div>
              </div>

              <div className='col-md-6'>
                <div className='value mt-5 mb-4'>Lease Details</div>

                <div className='label mt-4'>Status</div>
                <div className='value'>{productLease?.isActive ? 'Active' : 'Inactive'}</div>

                <div className='label mt-4'>Fully Paid</div>
                <div className='value'>{productLease?.isFullyPaid ? 'Yes' : 'No'}</div>

                <div className='label mt-4'>Auto Payment</div>
                <div className='value'>
                  {productLease?.autoPaymentEnabled ? 'Enabled' : 'Disabled'}
                </div>

                <div className='label mt-4'>Order Reference</div>
                <div className='value'>{productLease?.orderReference}</div>

                <div className='label mt-4'>Date Created</div>
                <div className='value'>{TimeConverter(productLease?.createdAt || '')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pay
        show={showPayModal}
        close={() => setShowPayModal(false)}
        balance={productLease?.totalDebtMajor || 0}
        currency={productLease?.currency || ''}
      />
    </div>
  )
}

export default ProductLeaseDetails
